// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".over-flow[data-v-88fee014]{word-break:break-all;text-overflow:ellipsis;white-space:normal;overflow:hidden;display:-webkit-box}.over-flow[data-v-88fee014],.rowheight1[data-v-88fee014]{-webkit-box-orient:vertical}.rowheight1[data-v-88fee014]{-webkit-line-clamp:1;line-clamp:1}.rowheight3[data-v-88fee014]{-webkit-line-clamp:3;line-clamp:3;-webkit-box-orient:vertical}.wid190[data-v-88fee014]{width:auto;max-height:64px;height:auto}p[data-v-88fee014]{margin:0}", ""]);
// Exports
module.exports = exports;
